import vsComponent from './vsSpacer'

export default Vue => {
  Vue.component(vsComponent.name, vsComponent)
}
